if (!customElements.get('cart-reservation-timer')) {
  customElements.define(
    'cart-reservation-timer',
    class CartReservationTimer extends HTMLElement {
      static duration = 8 * 60 * 1000;
      static cookieName = 'fluffdreamCartReservationEnd';

      connectedCallback() {
        this.output = this.querySelector('[data-reservation-time]');

        if (!this.output) {
          return;
        }

        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.startOrResume();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      }

      readCookie() {
        const match = document.cookie.match(
          new RegExp(`(?:^|; )${CartReservationTimer.cookieName}=([^;]*)`)
        );

        return match ? Number(decodeURIComponent(match[1])) : 0;
      }

      writeCookie(value) {
        const expires = new Date(Date.now() + 864e5).toUTCString();

        document.cookie = `${CartReservationTimer.cookieName}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
      }

      resetEndTime() {
        this.endTime = Date.now() + CartReservationTimer.duration;
        this.writeCookie(this.endTime);
      }

      startOrResume() {
        this.endTime = this.readCookie();

        if (!Number.isFinite(this.endTime) || this.endTime <= Date.now()) {
          this.resetEndTime();
        }

        this.tick();
        this.stop();
        this.interval = window.setInterval(() => this.tick(), 1000);
      }

      stop() {
        if (this.interval) {
          window.clearInterval(this.interval);
          this.interval = null;
        }
      }

      tick() {
        let timeLeft = this.endTime - Date.now();

        if (timeLeft <= 0) {
          this.resetEndTime();
          timeLeft = CartReservationTimer.duration;
        }

        const totalSeconds = Math.max(0, Math.ceil(timeLeft / 1000));
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        const formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        this.output.textContent = formattedTime;
        this.output.setAttribute('datetime', `PT${minutes}M${seconds}S`);
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.stop();
        } else {
          this.startOrResume();
        }
      }
    }
  );
}
